import { ForgotPasswordPage } from '@shared/pages/ForgotPasswordPage';
import { LoginPage } from '@shared/pages/LoginPage';
import { PasswordSentPage } from '@shared/pages/PasswordSentPage';
import { ResetPasswordPage } from '@shared/pages/ResetPasswordPage';
import { LOGIN_URL } from '@shared/utils/loginRedirect';
import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import '../app.css';
import { initThemeClass } from '@shared/utils/themeInit';

initThemeClass();

type Page = 'login' | 'forgot' | 'sent' | 'reset';

function getInitialPage(): { page: Page; token: string } {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const token = params.get('reset_password_token') || '';

  if (path.includes('/login/reset') || path.includes('/password/edit') || token) return { page: 'reset', token };
  if (path.includes('/login/sent') || path.includes('/password/sent')) return { page: 'sent', token: '' };
  if (path.includes('/login/forgot') || path.includes('/password/new') || path.includes('/forgot-password')) return { page: 'forgot', token: '' };
  return { page: 'login', token: '' };
}

function LoginApp() {
  const [checking] = useState(false);
  const initial = getInitialPage();
  const [page, setPage] = useState<Page>(initial.page);
  const [resetToken] = useState(initial.token);

  const navigate = (target: string) => {
    setPage(target as Page);
    const pathMap: Record<string, string> = {
      login: LOGIN_URL,
      forgot: '/login/forgot',
      sent: '/login/sent',
      reset: '/login/reset',
    };
    const base = pathMap[target] ?? LOGIN_URL;
    const q = target === 'reset' && resetToken ? `?reset_password_token=${encodeURIComponent(resetToken)}` : '';
    window.history.pushState({}, '', `${base}${q}`);
  };

  if (checking && page === 'login') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-app-bg">
        <div className="text-text-secondary">Cargando…</div>
      </div>
    );
  }

  switch (page) {
    case 'forgot':
      return <ForgotPasswordPage onNavigate={navigate} />;
    case 'sent':
      return <PasswordSentPage onNavigate={navigate} />;
    case 'reset':
      return <ResetPasswordPage token={resetToken} onNavigate={navigate} />;
    default:
      return <LoginPage onNavigate={navigate} />;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LoginApp />
  </StrictMode>,
);
